/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MisconfigurationExplorerWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("MisconfigurationExplorerWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return MisconfigurationExplorerWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<MisconfigurationExplorerWidgetConfiguration>): MisconfigurationExplorerWidgetConfiguration {
        let obj = Object.assign(new MisconfigurationExplorerWidgetConfiguration(), model);
        MisconfigurationExplorerWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MisconfigurationExplorerWidgetConfiguration>): MisconfigurationExplorerWidgetConfiguration {
        if (!model) return null;
        return MisconfigurationExplorerWidgetConfiguration.newInstance(<MisconfigurationExplorerWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MisconfigurationExplorerWidgetConfiguration) {
        if (!obj) return;

        models.MisconfigurationExplorerWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MisconfigurationExplorerWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, MisconfigurationExplorerWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
